document.addEventListener('DOMContentLoaded', function() {
  const collectionButtons = document.querySelectorAll('.collection-button');
  const toPageButton = document.getElementById('toPage');
  const toStep2FromStep3 = document.getElementById('toStep2FromStep3');

  let selectedButton = null;

  // Step 2 (商品选择) 的上一步按钮
  if (toStep2FromStep3) {
    toStep2FromStep3.addEventListener('click', () => {
      const stepWizard = document.querySelector("step-wizard");
      if (stepWizard) {
        stepWizard.activateStep(2); // 回到 Step 1 (信息确认)
      }
    });
  }
  
  if (toPageButton) {
    toPageButton.disabled = true;
  }
  
  collectionButtons.forEach(button => {
    button.addEventListener('click', function() {
      collectionButtons.forEach(btn => btn.classList.remove('active'));
      
      this.classList.add('active');
      
      selectedButton = this;
      
      if (toPageButton) {
        toPageButton.disabled = false;
      }
    });
  });
  
  if (toPageButton) {
    toPageButton.addEventListener('click', function() {
      if (selectedButton && !this.disabled) {
        const buttonId = selectedButton.id;
        const isRoaming = localStorage.getItem('isRoaming')
        const lang = document.documentElement.getAttribute('lang')
        
        // 获取 lineId 和 active_code
        const lineId = sessionStorage.getItem('lineId') || ''
        const active_code = sessionStorage.getItem('active_code')
        
        // 添加 loading 状态
        this.classList.add('loading');
        this.disabled = true;
        
        if (isRoaming) {
          if (buttonId === 'new-charge') {
            // 移除 loading 状态（因为不会跳转）
            this.classList.remove('loading');
            this.disabled = false;
            
            let text = '近日公開'
            if (lang === 'en') {
              text = 'Coming soon'
            } else if (lang === 'zh-CN') {
              text = '即将上线'
            }
            Message.error(text, 2000)
          } else {
            let data_charge= 'データ量のみリチャージ'
            let new_charge = '日数のみリチャージ'
            let region = ''
            if (lang === 'en') {
              data_charge = 'Recharge+only+the+data+volume'
              new_charge = 'Data+volume+and+number+of+days'
              region = '/en-us'
            } else if (lang === 'zh-CN') {
              data_charge = '仅充值数据流量'
              new_charge = '数据量和天数'
              region = '/zh-cn'
            }
            let final_category = buttonId === 'data-charge' ? data_charge : new_charge
            window.location.href = `${window.location.origin}${region}/collections/charge-products-roaming?filter.p.m.custom.category=${final_category}`;
          }
        } else {
          let data_charge= 'データ量のみリチャージ'
          let new_charge = '日数のみリチャージ'
          let region = ''
          if (lang === 'en') {
            data_charge = 'Data+only'
            new_charge = 'Data+and+number+of+days'
            region = '/en-us'
          } else if (lang === 'zh-CN') {
            data_charge = '仅充值数据流量'
            new_charge = '数据量和天数'
            region = '/zh-cn'
          }
          let final_category = buttonId === 'data-charge' ? data_charge : new_charge
          window.location.href = `${window.location.origin}${region}/collections/charge-products?filter.p.m.custom.category=${final_category}`;
        }
      }
    });
  }
});
